import { Panel } from "@appkit4/react-components";
import { Link } from "react-router-dom";
import "./acceptableUsePolicy.scss";

const AcceptableUsePolicyStatement = () => {
  return (
    <div className="ap-container">
      <Panel className="mt-4 mb-4 aup-panel">
        <div className="aup-page-content">
          <h2>Acceptable Use Policy</h2>

          <p>
            Please read these terms carefully. By using the PwC CIR Analyser
            platform (the "Platform"), you agree to comply with them. You may
            not use or continue to use the Platform unless you comply with these
            terms. The following conditions of use apply:
          </p>

          <h3>You must:</h3>
          <ul>
            <li>comply with all applicable laws and regulations;</li>
            <li>
              keep your login credentials complete, accurate and up-to-date at
              all times;
            </li>
            <li>
              keep your password secure and not disclose it to anyone else;
            </li>
            <li>
              not let anyone else use your login credentials in connection with
              the Platform;
            </li>
            <li>
              tell your PwC contact immediately if you lose your password or
              know or suspect someone else knows it; and
            </li>
            <li>
              not do anything to bypass the Platform's access or security
              controls or undermine the Platform's security in any way.
            </li>
          </ul>

          <h3>You must not:</h3>
          <ul>
            <li>
              upload, post or link to anything that is:
              <ul>
                <li>
                  illegal or infringes anyone else's intellectual property,
                  confidentiality or other rights or is defamatory, libellous,
                  threatening, abusive, offensive, misleading or otherwise
                  inappropriate;
                </li>
                <li>
                  harmful, including any virus or other computer code designed
                  or likely to harm the Platform; and
                </li>
                <li>
                  sensitive personal data relating to someone's race or ethnic
                  origin, political opinions, religious or other similar
                  beliefs, trade union membership, physical or mental health, or
                  sexual orientation.
                </li>
              </ul>
            </li>
            <li>
              intentionally distribute viruses, worms, Trojan horses, corrupted
              files, hoaxes, or other items of a destructive or deceptive
              nature;
            </li>
            <li>
              impersonate someone else or misrepresent information about you;
              and
            </li>
            <li>
              except to the extent permitted by applicable law, copy, modify,
              work around, by-pass, reverse engineer or otherwise change any
              part of the Platform, or attempt to do so.
            </li>
          </ul>

          <p className="aup-warning">
            <strong>
              We reserve the right to terminate or suspend your access if you
              breach this acceptable use policy.
            </strong>
          </p>

          <Link to="/" style={{ marginTop: "2rem", display: "inline-block" }}>
            ← Back to Home
          </Link>
        </div>
      </Panel>
    </div>
  );
};

export default AcceptableUsePolicyStatement;
